import React from 'react';

const ParadigmSection = () => {
  return (
    <section id="paradigm" style={{
      background: '#000000',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <h2 className="section-title" style={{
          fontSize: '48px',
          fontWeight: 600,
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          color: '#FFFFFF',
          marginBottom: '60px',
          textAlign: 'center'
        }}>
          THE PARADIGM
        </h2>

        <div className="two-col-grid" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '60px',
          alignItems: 'center'
        }}>
          <div>
            <h3 className="subsection-title" style={{
              fontSize: '32px',
              fontWeight: 600,
              lineHeight: 1.25,
              color: '#FFFFFF',
              marginBottom: '24px'
            }}>
              The Question We're Actually Asking
            </h3>
            
            <p className="content-text" style={{
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '20px'
            }}>
              Why these laws? Why this universe? Physicists have grown comfortable with "it just is"—accepting the Standard Model's nineteen free parameters as brute facts. We invoke anthropic principles and infinite multiverses to avoid the question.
            </p>

            <p className="content-text" style={{
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '20px'
            }}>
              Universe Engine Theory takes a different approach. It starts with a single constraint: the universe must be describable by laws that allow those laws to be discovered. From this bootstrap condition—this requirement of self-consistency across time—the mathematics forces a specific structure.
            </p>

            <p className="content-text" style={{
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)'
            }}>
              Not a simulation. Not intelligent design. A selection mechanism embedded in the mathematics of boundary-constrained systems.
            </p>
          </div>

          <div className="section-image" style={{
            position: 'relative',
            height: '400px',
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid rgba(255, 255, 255, 0.25)'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_omega-theory/artifacts/yehafz3v_image%201%20the%20paragdigm.png" 
              alt="Bootstrap Loop"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: 0.9
              }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          section {
            padding: 60px 20px !important;
          }
          .section-title {
            font-size: 36px !important;
            margin-bottom: 40px !important;
          }
          .subsection-title {
            font-size: 28px !important;
          }
          .two-col-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          .section-image {
            height: 300px !important;
          }
        }
        @media (max-width: 768px) {
          .section-title {
            font-size: 32px !important;
          }
          .subsection-title {
            font-size: 24px !important;
          }
          .content-text {
            font-size: 16px !important;
          }
          .section-image {
            height: 250px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ParadigmSection;